module.exports = __webpack_public_path__ + "static/media/project_11.65acfe30.svg";